import { Box, Button, Card, Grid2, IconButton, InputAdornment, List, ListItem, ListItemText, Stack, TextField, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import Loader from "../../util/Loader";
import LoadingAwal from "../../util/LoadingAwal";
import Barcode from "react-barcode";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { QRCodeCanvas } from "qrcode.react";
import { useFormik } from "formik";
import * as yup from "yup";

const validationSchema = yup.object().shape({
    phone: yup.string().required("input valid phone number").matches(/^8[0-9]{5,16}$/, "input valid phone number")
})

const Ovo = ({user_id, invoice_id}) => {
    const [loading, isLoading] = useState(false);
    const [proses, isProses] = useState(false);
    const [error, isError] = useState(false);
    const [errorMsg, setErrorMsg] = useState("");
    const [rows, setRows] = useState({});
    const navigate = useNavigate();

    const formik = useFormik({
        initialValues: {
            phone: ""
        },
        validationSchema,
        onSubmit: (e) => {
            isLoading(true)
            if(user_id && invoice_id) {
                axios.get(`https://ssr.radboox.com/data/xendit/ewallet_ovo/${user_id}?invoice_id=${invoice_id}&phone=${e.phone}`)
                .then((res) => {
                    const data = res.data.message;
                    setRows(data)
                    isLoading(false)
                    isProses(true)
                }).catch((e) =>{
                    isError(true)
                    setErrorMsg(e.response.data.message)
                    isLoading(false)
                })
            }
        }
    })

    return(
       <>
        {loading ? (
            <>
                <Loader />
                <LoadingAwal /> 
            </>
        ) : (
            <>
                {error ? (
                    <>
                        <Box display="flex" justifyContent="center" alignItems="center" flexDirection="column">
                            <Typography variant="body1">Mohon maaf, permintaan Anda tidak dapat di lanjutkan</Typography>
                            <Typography variant="body2">error code: {errorMsg}</Typography>
                            <Button sx={{marginY: 2, paddingX: 4, marginTop: 5}} variant="contained" onClick={() => navigate(-1)}>Kembali</Button>
                        </Box>
                    </>
                ) : (
                    <>
                        <Grid2 container justifyContent="center"> 
                            <Grid2 size={{xs: 12, sm: 7}}>
                                <Card variant="outlined" sx={{padding: 1}}>
                                    <Grid2 container padding={2} spacing={2}>
                                        <Grid2 size={{xs: 12, sm: 12}} order={{ xs: 2, sm: 1 }} justifyItems="center" alignContent="center">
                                            {!proses ? (<Stack alignItems={"center"} justifyContent={"center"} spacing={2}>
                                                <img
                                                    src={process.env.PUBLIC_URL + '/bank_logo/OVO.svg'}
                                                    alt="Company Profile"
                                                    style={{
                                                        align: "center",
                                                        maxWidth: "100px",
                                                        objectFit: "contain",
                                                        backgroundColor: "#fff",
                                                    }}
                                                />
                                                <form onSubmit={formik.handleSubmit}>
                                                    <Grid2 container spacing={1} marginTop={2}>
                                                        <Grid2 size={{xs: 12}}>
                                                        <TextField
                                                            fullWidth
                                                            label="Nomor Handphone"
                                                            id="phone"
                                                            name="phone"
                                                            sx={{ marginTop: 0 }}
                                                            value={formik.values.phone}
                                                            onChange={formik.handleChange}
                                                            error={formik.touched.phone && Boolean(formik.errors.phone)}
                                                            helperText={formik.touched.phone && formik.errors.phone}
                                                            slotProps={{
                                                                input: {
                                                                startAdornment: <InputAdornment position="start">+62</InputAdornment>,
                                                                },
                                                            }}
                                                        />
                                                        </Grid2>
                                                        <Grid2 size={{xs: 12}}>
                                                            <Stack direction="row" spacing={2} justifyContent={"center"}>
                                                            <Button
                                                                fullWidth
                                                                sx={{maxWidth: 130}}
                                                                variant="outlined"
                                                                type="button"
                                                                color="secondary"
                                                                onClick={()=> navigate(-1)}
                                                                >
                                                                {"Kembali"}
                                                            </Button>
                                                            <Button
                                                                fullWidth
                                                                sx={{maxWidth: 130}}
                                                                variant="contained"
                                                                type="submit"
                                                                >
                                                                {"Bayar"}
                                                            </Button>
                                                            </Stack>
                                                        </Grid2>
                                                    </Grid2>
                                                </form>
                                            </Stack>
                                            ) : (
                                                <Stack direction="column" spacing={2} alignItems={"center"} justifyContent={"center"}>
                                                    <Typography>Silahkan buka aplikasi OVO Anda untuk melanjutkan pembayaran</Typography>
                                                    <Button
                                                        fullWidth
                                                        sx={{maxWidth: 130}}
                                                        variant="outlined"
                                                        type="button"
                                                        color="secondary"
                                                        onClick={()=> navigate(-1)}
                                                        >
                                                        {"Kembali"}
                                                    </Button>
                                                </Stack>
                                            )
                                            }
                                        </Grid2>
                                    </Grid2>
                                </Card>
                            </Grid2>
                        </Grid2>
                    </>
                )}
            </>
        )}
       </>
    )
};

export default Ovo;